import { selectLoaderByEntity } from '../ui/ui.selectors';
import { SURVEY } from './survey.actions';

export const selectSurvey = (state) => state.survey;
export const selectSurveyValues = (state) => state.survey.values;
export const selectSurveyStep = (state) => state.survey.step;
export const selectSurveyStatus = (state) => selectLoaderByEntity(state, SURVEY);
